/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Overrides the type from meta info, e.g. assay value tables may contain in one column different types per cell
 * @export
 */
export const TypeConstants = {
    Boolean: 'Boolean',
    Date: 'Date',
    DateWithTime: 'DateWithTime',
    Float: 'Float',
    Integer: 'Integer',
    String: 'String',
    ExternalLink: 'ExternalLink',
    FileUpload: 'FileUpload',
    Image: 'Image',
    InternalLink: 'InternalLink',
    Sequence: 'Sequence',
    ValueSpecific: 'ValueSpecific',
    Password: 'Password'
} as const;
export type TypeConstants = typeof TypeConstants[keyof typeof TypeConstants];


export function TypeConstantsFromJSON(json: any): TypeConstants {
    return TypeConstantsFromJSONTyped(json, false);
}

export function TypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeConstants {
    return json as TypeConstants;
}

export function TypeConstantsToJSON(value?: TypeConstants | null): any {
    return value as any;
}

